export default __webpack_public_path__ + "7c96ee5015509af41b04b4bc80a22138.gif";